import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getCustomerApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code || data?.error?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED' || code === 'UPDATED_AT_INVALID') {
    return data?.message || '更新時間無效，請重新載入後再試';
  }

  if (code === 'CRM_CUSTOMER_STATUS_INVALID') {
    return data?.message || '目前狀態無法執行此操作';
  }

  if (code === 'CRM_CUSTOMER_CODE_ALREADY_EXISTS') {
    return data?.message || '客戶代碼已存在';
  }

  if (code === 'CRM_CUSTOMER_SN_CODE_ALREADY_EXISTS') {
    return data?.message || 'SN 前綴已被其他客戶使用';
  }

  if (code === 'CRM_CUSTOMER_SN_CODE_IN_USE') {
    return data?.message || '此 SN 前綴已被對照使用，不能修改或清空';
  }

  if (code === 'CRM_CUSTOMER_DEACTIVATE_BLOCKED_BY_ACTIVE_SN_MAPPINGS') {
    return data?.message || '客戶仍有啟用中的 物料序號，請先停用那些對照';
  }

  if (code === 'CRM_CUSTOMER_ADDRESS_VALUE_REQUIRED') {
    return data?.message || '地址列的地址不能為空';
  }

  return data?.message || fallback;
}

export function isCustomerVersionConflict(error) {
  const data = error?.response?.data;
  return (data?.code || data?.error?.code) === 'RESOURCE_VERSION_CONFLICT';
}
